import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Distributor } from '../../models/distributor';
import { DistributorsService } from '../services/distributors.service';

@Injectable()
export class DistributorResolver implements Resolve<Distributor>
{
	private distributorsService: DistributorsService;

	constructor(distributorsService: DistributorsService)
	{
		this.distributorsService = distributorsService;
	}

	resolve(route: ActivatedRouteSnapshot): Promise<Distributor>
	{
		return this.distributorsService.getDistributorById(+route.params['distributorId']);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/resolvers/distributor.resolver.ts